<template>
	<v-card class="mx-auto" elevation="0">
		<v-card-title class="card-header fixed-card-title2">
			{{ $t('add-organization-mapping-pcc') }}
			<v-spacer></v-spacer>
			<v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
		</v-card-title>
		<v-card-text>
			<v-row class="mt-2">
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="pccCompanyGuid"
						:label="`${$t('organization')} GUID`"
						required
						:readonly="viewDataState !== null">
					</v-text-field>
				</v-col>
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="pccCompanyName"
						:label="`${$t('organization')} ${$t('name')} `"
						required
						:readonly="viewDataState !== null">
					</v-text-field>
				</v-col>
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-select
						class="py-1"
						hide-details
						dense
						v-model="selectedMedicalInstitution"
						:items="allMedicalInstitutions"
						item-value="id"
						item-text="institutionName"
						:label="$t('medical-institutions')"
						outlined>
					</v-select>
				</v-col>
				<!-- <v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="pccCompanyCode"
						:label="`${$t('organization')} ${$t('code')} `"
						required>
					</v-text-field>
				</v-col> -->
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-textarea rows="3" v-model="description" outlined dense :label="$t('description')"></v-textarea>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions class="fixed-card-actions">
			<v-row dense class="mx-0 px-0 mr-2">
				<v-col cols="6">
					<v-btn elevation="0" @click="closeDrawer" class="cancel-button-style capitalize-text">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn :disabled="isSaveButtonDisabled()" @click="saveOrganizationMapping" class="save-button-style">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
	name: 'OrganizationMappingAdd',
	data: () => ({
		componentKey: 0,
		menu: false,
		defaultTimeZone: 'America/Chicago',
		selectedMedicalInstitution: null,
		pccCompanyGuid: '',
		pccCompanyName: '',
		description: '',
		// pccCompanyCode: '',
	}),
	computed: {
		...mapState({
			allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
			hospitals: (state) => state.hospitals.hospitals,
		}),
		...mapGetters({
			getTimeZone: 'verifiers/getTimeZone',
		}),
		detailsDrawer () {
			return this.$store.state.detailsDrawer;
		},
		viewDataState: {
			get () {
				return this.$store.state.item;
			},
			set (value) {
				this.$store.state.item = value;
			},
		},
	},
	mounted () {
		this.pccCompanyGuid = this.viewDataState?.orgUuid || '';
		this.pccCompanyName = this.viewDataState?.pccOrganizationName || '';
		this.getMedicalInstitutions();
	},
	methods: {
		...mapActions({
			getMedicalInstitutions: 'medicalInstitutions/getMedicalInstitutions',
			addPccMapForCompany: 'pcc/addPccMapForCompany',
		}),
		isSaveButtonDisabled () {
			return (
				!this.selectedMedicalInstitution ||
				this.pccCompanyGuid.trim().length === 0 ||
				this.pccCompanyName.trim().length === 0 ||
				// this.pccCompanyCode.trim().length === 0 ||
				this.description.trim().length === 0
			);
		},
		resetComponent () {
			this.selectedMedicalInstitution = null;
			this.pccCompanyGuid = '';
			this.pccCompanyName = '';
		},
		async saveOrganizationMapping () {
			const body = {
				medicalInstitutionId: this.selectedMedicalInstitution,
				pccCompanyGuid: this.pccCompanyGuid.trim(),
				pccCompanyName: this.pccCompanyName.trim(),
				pccCompanyCode: '-',
				description: this.description,
				additionalData: null,
			};
			this.addPccMapForCompany(body).then((res) => {
				this.closeDrawer();
			});
		},
		closeDrawer () {
			this.resetComponent();
			this.selectedMedicalInstitution = null;
			this.pccCompanyGuid = '';
			this.pccCompanyName = '';
			this.description = '';
			// this.pccCompanyCode = '';
			this.$store.commit('SET_DETAILS_DRAWER', false);
			this.viewDataState = null;
		},
	},
	watch: {
		detailsDrawer (val) {
			if (val) {
				this.pccCompanyGuid = this.viewDataState?.orgUuid || '';
				this.pccCompanyName = this.viewDataState?.pccOrganizationName || '';
			}
		},
	},
};
</script>
<style scoped>
.map-container {
	margin-top: 20px;
	/* Adjust this margin as needed */
}
</style>
